import React from 'react';
import {
  ShoppingBag, Heart, GraduationCap, Building2, Banknote,
  PlayCircle, TrendingUp, Users,
} from 'lucide-react';

const solutions = [
  {
    icon: ShoppingBag,
    title: 'E-Commerce Platforms',
    description: 'Complete online retail solutions with inventory management, payment processing, and customer analytics.',
  },
  {
    icon: Heart,
    title: 'Healthcare Applications',
    description: 'HIPAA-compliant telehealth platforms, patient management systems, and medical record solutions.',
  },
  {
    icon: GraduationCap,
    title: 'Education Technology',
    description: 'Interactive learning platforms, virtual classrooms, and comprehensive student management systems.',
  },
  {
    icon: Building2,
    title: 'Enterprise Solutions',
    description: 'Custom ERP systems, workflow automation, and business intelligence dashboards for large organizations.',
  },
  {
    icon: Banknote,
    title: 'Financial Services',
    description: 'Secure banking applications, investment platforms, and blockchain-based financial solutions.',
  },
  {
    icon: PlayCircle,
    title: 'Media & Entertainment',
    description: 'Streaming platforms, content management systems, and interactive media applications.',
  },
  {
    icon: TrendingUp,
    title: 'Data Analytics',
    description: 'Real-time analytics dashboards, predictive modeling, and business intelligence solutions.',
  },
  {
    icon: Users,
    title: 'Social Platforms',
    description: 'Community building applications, social networks, and collaborative workspace solutions.',
  },
];

const Solutions = () => {
  return (
    <section id="solutions" className="relative py-24 md:py-32 bg-paper-3/40 border-y border-rule-soft">
      <div className="frame">
        {/* Masthead */}
        <header className="grid grid-cols-12 gap-x-6 lg:gap-x-10 items-end pb-6 border-b border-ink">
          <div className="col-span-12 lg:col-span-5 flex items-center gap-3">
            <span className="section-num">03 / Solutions</span>
            <span className="label-muted">Industry verticals</span>
          </div>
          <div className="col-span-12 lg:col-span-7 mt-6 lg:mt-0">
            <h2 className="display-lg">
              Industry <span className="text-accent">Solutions</span>
            </h2>
            <p className="mt-5 max-w-measure text-ink-soft leading-relaxed">
              Specialized applications designed to address the unique challenges and
              opportunities in various industries.
            </p>
          </div>
        </header>

        {/* Industries grid */}
        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-rule-soft border border-rule-soft">
          {solutions.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                className="group relative bg-paper-2 p-6 md:p-7 min-h-[220px] flex flex-col justify-between cursor-default transition-colors hover:bg-lime"
              >
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 flex items-center justify-center border border-ink bg-paper group-hover:bg-paper-2 transition-colors">
                    <Icon className="w-5 h-5 text-ink" strokeWidth={1.5} />
                  </div>
                  <span className="label-muted group-hover:text-ink">{String(i + 1).padStart(2, '0')}</span>
                </div>

                <div className="mt-6">
                  <h3 className="font-display font-semibold text-lg md:text-xl text-ink tracking-tight leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-ink-soft text-[13px] leading-relaxed group-hover:text-ink">
                    {s.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 grid grid-cols-12 gap-x-6 lg:gap-x-10 items-center">
          <p className="col-span-12 lg:col-span-7 text-ink-soft max-w-measure">
            Don't see your industry? We create custom solutions for any business vertical.
          </p>
          <div className="col-span-12 lg:col-span-5 mt-5 lg:mt-0 lg:text-right">
            <button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="btn-ink"
            >
              <span>Discuss Your Project</span>
              <span aria-hidden>→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
